module.exports = __webpack_public_path__ + "static/media/093-british-indian-ocean-territory.420b804d.svg";